var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['main-box d-flex flex-column align-center', _vm.parentClass],style:([_vm.parentStyle, _vm.marginLastChildCss]),on:{"click":function($event){return _vm.$emit('clicked')}}},[(_vm.cardTitle)?_c('div',{staticClass:"font_5 bold mb-4 align-self-start"},[_vm._v(" "+_vm._s(_vm.cardTitle)+" ")]):_vm._e(),_c('v-card',{class:[
      'w-100 main-card radius-4',
      _vm.customCardClass,
      _vm.$vuetify.breakpoint.xsOnly ? 'pa-6' : 'pa-8',
    ],style:(_vm.customCardStyle),attrs:{"outlined":"","flat":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }